import { useIdleTimer } from "react-idle-timer";
import { timeSymbolToMilliseconds } from "../utils/helpers";

const useCustomIdleTimer = (onIdle: () => void, time: string) => {
  const idleTimer = useIdleTimer({
    timeout: timeSymbolToMilliseconds(time),
    onIdle: onIdle,
    debounce: 500,
    events: [
      "mousemove",
      "keydown",
      "keypress",
      "wheel",
      "touchmove",
      "scroll",
      "click",
    ],
  });

  return idleTimer;
};

export default useCustomIdleTimer;
